import { DataModelBuilder, SerializationContext, SerializedData } from '../../../dto/data-model.js';
import { Payload } from '../payload.js';
import { PayloadType } from '../payload-type.js';
import { MapUtils } from '../../../../utility/map-utils.js';
import { cloneList, isSameList } from '../../../dto/data-model-utils.js';
import { SeatWithTicketTemplateDto } from './dtos/seat-with-ticket-template-dto.js';

export class SeatSelectionChangedPayload extends Payload {
  static readonly TYPE_ID = 'dccdcdf6bd0e4b78966fe4d4e8f952fd';

  private constructor(
    public readonly deselectedSeats: SeatWithTicketTemplateDto[],
    public readonly newlySelectedSeats: SeatWithTicketTemplateDto[],
  ) {
    super();
  }

  get $typeId(): string {
    return SeatSelectionChangedPayload.TYPE_ID;
  }

  get type(): PayloadType {
    return PayloadType.SeatSelectionChanged;
  }

  static create(args: {
    deselectedSeats: SeatWithTicketTemplateDto[];
    newlySelectedSeats: SeatWithTicketTemplateDto[];
  }): SeatSelectionChangedPayload {
    return new SeatSelectionChangedPayload(args.deselectedSeats, args.newlySelectedSeats);
  }

  static fromMap(context: SerializationContext, map: SerializedData): SeatSelectionChangedPayload {
    return SeatSelectionChangedPayload.create({
      deselectedSeats: MapUtils.getList<SeatWithTicketTemplateDto>(map, 'deselectedSeats', (value) => context.fromData<SeatWithTicketTemplateDto>(value as SerializedData)),
      newlySelectedSeats: MapUtils.getList<SeatWithTicketTemplateDto>(map, 'newlySelectedSeats', (value) => context.fromData<SeatWithTicketTemplateDto>(value as SerializedData)),
    });
  }

  toMap(_context: SerializationContext): SerializedData {
    return {
      'deselectedSeats': this.deselectedSeats,
      'newlySelectedSeats': this.newlySelectedSeats,
    };
  }

  clone(): this {
    return this.copyWith();
  }

  copyWith({
    deselectedSeats = cloneList(this.deselectedSeats),
    newlySelectedSeats = cloneList(this.newlySelectedSeats),
  }: {
    deselectedSeats?: SeatWithTicketTemplateDto[];
    newlySelectedSeats?: SeatWithTicketTemplateDto[];
  } = {}): this {
    return SeatSelectionChangedPayload.create({ deselectedSeats: deselectedSeats, newlySelectedSeats: newlySelectedSeats }) as this;
  }

  isSame(other: SeatSelectionChangedPayload): boolean {
    return this === other || (
      isSameList(this.deselectedSeats, other.deselectedSeats) &&
      isSameList(this.newlySelectedSeats, other.newlySelectedSeats)
    );
  }
}

export class SeatSelectionChangedPayloadBuilder extends DataModelBuilder<SeatSelectionChangedPayload> {
  build(context: SerializationContext, map: SerializedData): SeatSelectionChangedPayload {
    return SeatSelectionChangedPayload.fromMap(context, map);
  }
}
